import React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { AnimatedSection } from "./AnimatedSection";

interface CTASectionProps {
  visibleSections: Record<string, boolean>;
}

export const CTASection: React.FC<CTASectionProps> = ({ visibleSections }) => {
  return (
    <section className="py-16 sm:py-24 lg:py-32 px-4 sm:px-6 bg-gradient-to-br from-purple-50 to-purple-100 dark:from-purple-950/30 dark:to-black transition-colors duration-300">
      <AnimatedSection
        id="final-cta"
        className="container mx-auto max-w-4xl text-center"
        visible={visibleSections["final-cta"] ?? true}
      >
        <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 sm:mb-8 tracking-tight text-gray-900 dark:text-white">
          Pronto para começar?
        </h2>
        <p className="text-lg sm:text-xl md:text-2xl text-gray-600 dark:text-gray-400 mb-8 sm:mb-12 font-light px-4">
          Transforme a forma como você treina e gerencia seus alunos
        </p>

        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
          <Link
            to="/cadastrar"
            className="group px-8 sm:px-10 py-3 sm:py-4 bg-gradient-to-r from-purple-600 to-purple-700 text-white font-semibold text-base sm:text-lg rounded-full hover:from-purple-500 hover:to-purple-600 transition-all duration-300 inline-flex items-center gap-2 justify-center transform hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/50"
          >
            Começar agora
            <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
          <a
            href="/login"
            className="px-8 sm:px-10 py-3 sm:py-4 bg-white/50 dark:bg-white/10 backdrop-blur-sm border-2 border-gray-300 dark:border-gray-700 text-gray-900 dark:text-white font-semibold text-base sm:text-lg rounded-full hover:bg-white/80 dark:hover:bg-white/20 hover:border-purple-400 dark:hover:border-purple-500 transition-all duration-300 inline-flex items-center justify-center transform hover:scale-105"
          >
            Fazer login
          </a>
        </div>
      </AnimatedSection>
    </section>
  );
};
